import { useEffect, useState } from 'react';
import { useI18n } from '../i18n';

// 距下一道题(UTC 次日 0 点)的实时倒计时
function remaining(): number {
  const now = new Date();
  const next = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1, 0, 0, 0);
  return Math.max(0, next - now.getTime());
}
function fmt(ms: number): string {
  const s = Math.floor(ms / 1000);
  const h = String(Math.floor(s / 3600)).padStart(2, '0');
  const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
  const ss = String(s % 60).padStart(2, '0');
  return `${h}:${m}:${ss}`;
}

export default function Countdown() {
  const { t } = useI18n();
  const [ms, setMs] = useState(() => remaining());
  useEffect(() => {
    const id = setInterval(() => {
      const r = remaining();
      setMs(r);
      if (r <= 0) {
        clearInterval(id);
        setTimeout(() => location.reload(), 1500); // 跨过午夜后刷新到新一题
      }
    }, 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <p className="countdown">
      {t.nextIn} <b>{fmt(ms)}</b>
    </p>
  );
}
